import { render } from "./CustomerFeedbackManagement.vue?vue&type=template&id=7625139c&scoped=true"
import script from "./CustomerFeedbackManagement.vue?vue&type=script&lang=js"
export * from "./CustomerFeedbackManagement.vue?vue&type=script&lang=js"

import "./CustomerFeedbackManagement.vue?vue&type=style&index=0&id=7625139c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7625139c"]])

export default __exports__